<div class="{{ getCss() }}">
  <mat-icon matTooltip="{{ scoresUsedInCalculations }}">announcement</mat-icon>
  <h4 class="mat-h4">{{ title }}</h4>
  <h2 class="mat-h2">{{ formatScore(score) }}</h2>
  <h4 class="mat-h4"></h4>
</div>
